import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/shared/service/navigation.service';
import { UserService } from 'src/app/shared/service/user.service';

@Component({
    selector: 'app-page-login',
    templateUrl: './page-login.component.html',
    styleUrls: ['./page-login.component.scss'],
    imports: [ReactiveFormsModule]
})
export class PageLoginComponent {
  loginForm: FormGroup;

  constructor(private fb: FormBuilder, protected nav: NavigationService, private userService: UserService) {
    this.loginForm = this.fb.group({
      email: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  submit() {
    this.userService.login(this.loginForm);
  }
}
